import { useEffect } from 'react';
import { toast } from 'react-toastify';

import { LocalStore } from 'constants/localstore';
import { useAppDispatch } from 'store/store-hooks';
import { Path, useAppNavigator } from 'components/_hooks/use-router';
import { ModalEnum, setModal } from 'components/app/_mediator/app.slice';

type Redirect =
  | '/redirect/subscriptions'
  | '/redirect/subscriptions?r=true'
  | '/redirect/subscriptions?r=false'
  | '/redirect/finalcuts?r=true'
  | '/redirect/finalcuts?r=false';

export const useAppRedirect = () => {
  const { navigateTo } = useAppNavigator();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const redirect = localStorage.getItem(LocalStore.redirect) as Redirect;
    if (redirect) {
      localStorage.removeItem(LocalStore.redirect);
      switch (redirect) {
        case '/redirect/subscriptions':
          dispatch(setModal(ModalEnum.subscription));
          break;
        case '/redirect/subscriptions?r=true':
          toast.success('Subscription activated. Thank you for your purchase!');
          break;
        case '/redirect/subscriptions?r=false':
          toast.error('Unable to activate subscription. Try again later or contact support.');
          break;
        case '/redirect/finalcuts?r=true':
          navigateTo(Path.finalcuts);
          toast.success('Payment complete. Check your email for the receipt.');
          break;
        case '/redirect/finalcuts?r=false':
          navigateTo(Path.finalcuts);
          toast.error('Unable to process the payment. If this continues, please contact support.');
          break;
        default:
          console.warn(`Unknown redirect: ${redirect}`);
          toast.error('Unexpected redirect. Please try again.');
          break;
      }
    }
  }, []);
};
